// src/modules/app-views/goodsReceipt/pages/Document/tabs/RecordTab/IssuerCard.jsx
// *******************************************************************************
// ISSUER CARD (EMISSOR)
// *******************************************************************************
// Card for selecting and displaying the issuer (emitente) of the goods receipt.
// Reuses the invoices RecipientCard component with name="issuer" to get the same
// entity selection, info display, and form field handling.
//
// The issuer can be:
// - An external supplier (most common case)
// - The company itself (transfer, return, internal operations)
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import RecipientCard from 'modules/app-views/invoices/pages/Document/tabs/RecordTab/RecipientCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const IssuerCard = ({ data, viewMode, onActionsChange }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <RecipientCard
      data={data}
      viewMode={viewMode}
      onActionsChange={onActionsChange}
      name="issuer"
      label="search_issuer"
      entityProfiles={['supplier', 'company']}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default IssuerCard;
